import { handleActions } from 'redux-actions';
import { RemoteData } from 'rf-lib';
import * as t from './constants';

const defaultState = {
  groupDetailsState: RemoteData.NotAsked,
  allBalanceState: RemoteData.NotAsked,
  allGameRunnersState: RemoteData.NotAsked,
};

const reducer = handleActions({
  [t.FETCH_GROUP_DETAILS]: (state, action) => ({
    ...state, groupDetailsState: RemoteData.Loading
  }),

  [t.FETCH_GROUP_DETAILS_FAILURE]: (state, action) => ({
    ...state, groupDetailsState: RemoteData.Failure(action.payload)
  }),

  [t.FETCH_GROUP_DETAILS_SUCCESS]: (state, action) => ({
    ...state, groupDetailsState: RemoteData.Success(action.payload)
  }),

  [t.FETCH_GROUP_BALANCE]: (state, action) => ({
    ...state, allBalanceState: RemoteData.Loading
  }),
  [t.FETCH_GROUP_BALANCE_FAILURE]: (state, action) => ({
    ...state, allBalanceState: RemoteData.Failure(action.payload)
  }),
  [t.FETCH_GROUP_BALANCE_SUCCESS]: (state, action) => ({
    ...state, allBalanceState: RemoteData.Success(action.payload)
  }),

  [t.FETCH_ALL_GAMERUNNERS]: (state, action) => ({
    ...state, allGameRunnersState: RemoteData.Loading
  }),

  [t.FETCH_ALL_GAMERUNNERS_FAILURE]: (state, action) => ({
    ...state, allGameRunnersState: RemoteData.Failure(action.payload)
  }),

  [t.FETCH_ALL_GAMERUNNERS_SUCCESS]: (state, action) => ({
    ...state, allGameRunnersState: RemoteData.Success(action.payload)
  }),
}, defaultState);

export default reducer;
